import React from 'react';

import { ReactComponent as AddFaqSvg } from '../../../assets/add_faq.svg';
import { BoardOverviewFragment, useGetBoardByIdQuery } from '../../../graphql/gen/types';
import { ButtonColor, PlexButton } from '../../shared/primitives/PlexButton';
import { useDialogState } from '../dialog/useDialogState';
import { canCreateFact } from '../permissions';

interface Props {
  className?: string;
  board: BoardOverviewFragment;
}

export const NewQuestionButton = ({ board, className }: Props): React.ReactElement => {
  const [, setDialogState] = useDialogState();
  const handleClickOpen = (): void => {
    setDialogState({ type: 'new_card', boardId: board.id });
  };

  const userRelation = board.plex.currentUserRelation.state;

  const disabledReason: string | undefined = !canCreateFact(userRelation)
    ? "You don't have permission to create a card."
    : undefined;

  const label = 'Create Card';

  return (
    <PlexButton
      disabled={disabledReason != null}
      className={className}
      onClick={handleClickOpen}
      label={label}
      SvgIconRight={AddFaqSvg}
      color={ButtonColor.Primary}
      tooltip={disabledReason}
    />
  );
};

export const NewQuestionButtonContainer = ({
  boardId,
  className,
}: {
  boardId: string;
  className?: string;
}): React.ReactElement | null => {
  const { data } = useGetBoardByIdQuery({ variables: { boardId } });

  if (data?.loggedIn?.boardById == null) {
    return null;
  }

  return <NewQuestionButton board={data.loggedIn.boardById} className={className} />;
};
